export const API_RESP_CODE =  {
  SUCCESS: 0,
  ERROR: 10000 /** 错误 */,
};
